import { render } from "./reg.vue?vue&type=template&id=bd7c1d92&scoped=true"
import script from "./reg.vue?vue&type=script&lang=js"
export * from "./reg.vue?vue&type=script&lang=js"

import "./reg.vue?vue&type=style&index=0&id=bd7c1d92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd7c1d92"]])

export default __exports__